import request from '@utils/request';

import { OrderSchema } from './schemas';

export async function getGuestOrder({
  guestId,
  orderId,
  siteId,
  headers = {},
}: {
  guestId: number;
  orderId: number;
  siteId: number;
  headers?: object;
}) {
  const response = await request.base.get(`${siteId}/guests/${guestId}/orders/${orderId}`, {
    isPayloadCaseConverterDisabled: true,
    headers,
  });

  return OrderSchema.parse(response.data);
}

export async function getUnauthenticatedOrder({
  propertyId,
  orderId,
}: {
  propertyId: string;
  orderId: string;
}) {
  const response = await request.base.get(`${propertyId}/orders/unauthenticated/${orderId}`);
  return OrderSchema.parse(response.data);
}

const modificationConfig = {
  headers: {
    Accept: 'application/vnd.onejourney.latest+json',
  },
};

export async function amendOrder({
  orderId,
  message,
  guestEmail,
  guestUuid,
  siteSlug,
}: {
  orderId: string;
  message: string;
  guestEmail?: string;
  guestUuid?: string;
  siteSlug: string;
}) {
  return await request.base.post(
    `ordering/modification/site/${siteSlug}/order/${orderId}/customer-request`,
    {
      data: {
        _type: 'ModificationRequest',
        email: guestEmail ?? null,
        accountId: guestUuid ?? null,
        changeRequest: {
          type: 'Modification',
          note: message,
        },
      },
    },
    modificationConfig
  );
}

export async function cancelOrder({
  orderId,
  message,
  guestEmail,
  guestUuid,
  siteSlug,
}: {
  orderId: string;
  message: string;
  guestEmail?: string;
  guestUuid?: string;
  siteSlug: string;
}) {
  return await request.base.post(
    `ordering/modification/site/${siteSlug}/order/${orderId}/customer-request`,
    {
      data: {
        _type: 'ModificationRequest',
        email: guestEmail ?? null,
        accountId: guestUuid ?? null,
        changeRequest: {
          type: 'Cancellation',
          note: message,
        },
      },
    },
    modificationConfig
  );
}

export async function newCancelOrder({
  orderId,
  reason,
  siteUuid,
  orderItemIds,
}: {
  orderId: number;
  reason: string;
  siteUuid: string;
  orderItemIds: number[];
}) {
  return await request.base.post(
    `/store/${siteUuid}/v1/order-item-cancellation/${orderId}`,
    {
      data: {
        _type: 'OrderItemCancellation',
        orderItemIds,
        reason,
      },
    },
    modificationConfig
  );
}
